var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"font-weight-medium lighten-2",attrs:{"clipped-left":"","dark":"","color":"indigo","clipped":"","bottom":"","app":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v("\n    © "+_vm._s(new Date().getFullYear())+" —\n    "),_c('strong',[_vm._v("Bright Light Ventures Inc.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }